import React, { useState } from "react";

const RadioButtonList = ({
	name,
	dataItems = [
		{ id: 1, text: "Option 1", checked: false },
		{ id: 2, text: "Option 2", checked: false },
		{ id: 3, text: "Option 3", checked: false },
	],
	handleChange,
	className,
	disabled = false,
}) => {
	const handleRadioChange = (itemId) => {
		handleChange(itemId);
	};
	return (
		<div className={`space-y-2 flex flex-row items-end gap-2 ${className}`}>
			{dataItems.map((item) => (
				<label key={item.id} className=" items-start space-x-1 p-1 flex mr-4">
					<input
						disabled={disabled}
						name={
							name === "" || name === undefined || name === null || name === " "
								? "(Name is not defined)"
								: name
						}
						type="radio"
						className="form-radio h-5 w-5 text-blue-600 my-auto"
						value={item.id}
						checked={item.checked}
						onChange={() => handleRadioChange(item.id)}
					/>
					<span className="my-auto">{item.text}</span>
				</label>
			))}
		</div>
	);
};

export default RadioButtonList;
